import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../styles/dashboard-styles';
import Grid from '@material-ui/core/Grid';

function Slide(props) {
  const slides = props.slide.map(card => {
    return card;
  })
  return (
    <Grid container spacing={16}>
      {slides}
    </Grid>
  )
}


Slide.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Slide);



// WEBPACK FOOTER //
// ./src/components/slideshow/Slide.js